import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import AppBlueprintPicker from './AppBlueprintPicker';

export type BlueprintOption = {
  value: string;
  label: string;
  description: string;
  readmeUrl: string;
  tags?: string[];
};

export const AppBlueprintPickerFieldSchema = makeFieldSchema({
  output: z => z.string().describe('The URL of the selected app blueprint repository'),
  uiOptions: z =>
    z.object({
      items: z
        .array(
          z.object({
            value: z.string().describe('The blueprint repository URL used by the scaffolder'),
            label: z.string().describe('The card title shown to users'),
            description: z.string().describe('Short explanation of what the blueprint provides'),
            readmeUrl: z.string().describe('External link to README or repository documentation'),
            tags: z.array(z.string()).optional().describe('Optional short tags displayed as chips'),
          }),
        )
        .min(1)
        .describe('App blueprint options to render as selectable cards'),
    }),
});

export type AppBlueprintPickerProps = typeof AppBlueprintPickerFieldSchema.TProps;

export default AppBlueprintPicker;
